<template>
  <div>
    <el-card class="main_form">
      <div>
        <!-- <div class="title_box"> -->
        <!-- 操作按钮部分 -->
        <!-- <div class="operation_box" v-if="isedite != 2">
            <el-button @click="addExaminee">
              <i class="iconfont icon-xinzeng"></i>添加</el-button
            >
            <el-button @click="delectArr()">
              <i class="iconfont icon-zu11540"></i> 批量删除
            </el-button>
          </div> -->
        <!-- 账号搜索 -->
        <!-- <div class="search_view">
            <div class="search">
              <el-input
                v-model="input"
                placeholder="根据考生姓名或账号搜索"
                type="text"
              ></el-input>
              <el-button @click="searchResult">
                <i class="iconfont icon-sousuo"></i>
              </el-button>
            </div>
            <el-button @click="reset" icon="el-icon-refresh" class="searchbtn">
              重置
            </el-button>
          </div> -->
        <!-- </div> -->
        <!-- 表格 -->
        <div class="examinee_form">
          <!-- <p>已选{{ getData.length }}人，科室{{ this.unique() }}个</p>
          <el-table
            ref="tabledata"
            :data="list_vip"
            style="width: 100%"
            height="710"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
            @row-click="StepsListRowClick"
            :header-cell-style="{
              'background-color': '#8FCBFF',
              color: '#333333',
              height: '60px',
            }"
          >
            <el-table-column type="selection" width="80"></el-table-column>
            <el-table-column type="index" label="序号"> </el-table-column>
            <el-table-column
              v-for="(item, index) in formColumns"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              height="150"
              label-height="50"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              align="center"
              v-if="isedite != 2"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click.stop="delectstudent(scope.row, scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table> -->
          <Candidate
            v-if="isShow == true"
            ref="candidate"
            :types="types"
            :isedite="isedite"
            :editData="editType == true ? list_vip : 'null'"
          />
          <div v-else class="null_view" v-loading="loading">暂无数据</div>
        </div>
        <!-- 按钮 -->
        <div class="baic_content">
          <div class="operation">
            <el-button class="succ_btn" @click="back">返回</el-button>
            <el-button
              type="success"
              class="submit_btn"
              @click="next"
              :loading="sundflag"
              >{{
                isedite == 0 || isedite == 1 ? "发布视频" : "完成"
              }}</el-button
            >
          </div>
        </div>
      </div>
    </el-card>
    <!-- 进度条 -->
    <el-dialog
      title="提示"
      :visible.sync="progressdialog.isshow"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-progress
        :text-inside="true"
        :stroke-width="24"
        :percentage="parseFloat(progressdialog.percentagenum.toFixed(2))"
        v-if="!isNaN(parseInt(progressdialog.percentagenum.toFixed(2)))"
        status="success"
      ></el-progress>
    </el-dialog>
    <FourPup ref="popup" :currentRow="currentRow" />
  </div>
</template>

<script>
import OSS from "ali-oss"; //引入oss
import resourcereq from "@/api/resources";
import getstudentlist from "@/api/questionbank";
import Candidate from "../../../../components/addCandidate/Candidate.vue";
import FourPup from "@/views/theonlineTest/published/components/newaddpaper/components/FourPup";
// import FourPup from "./FourPup.vue"; //添加考生的弹窗

export default {
  data() {
    return {
      progressdialog: {
        isshow: false,
        percentagenum: 0,
      }, //进度弹窗
      loading: true,
      types: 0,
      sundflag: false, // 提交的防抖
      input: "",
      textarea: "",
      isedite: "",
      reducesum: "", //总分
      inputtestname: "", //考试名称
      activeNames: ["1"],
      isactiveNames: ["1"],
      value1: [], //开始和结束的时间
      StartDatestr: "", //开始的时间
      EndDate: "", //
      textarea2: " ", //注意事项
      getData: [],
      list_vip: [], // 新定义的数组
      currentPage3: 0, //  当前页数
      pageSize: 10,
      total: 100,
      currentRowData: {},
      currentRow: {}, //删除的对象。
      editType: false, // 编辑状态
      formColumns: [
        {
          prop: "RealName",
          label: "考生姓名",
          // width: "90px",
        },
        {
          prop: "UserName",
          label: "考生账号",
          // width: "90px",
        },
        {
          prop: "DepartmentName",
          label: "科室名称",
          // width: "90px",
        },
        {
          prop: "PTitle",
          label: "职称",
          // width: "90px",
        },
        {
          prop: "Position",
          label: "职位",
          // width: "90px",
        },
        {
          prop: "Birthday1",
          label: "出生日期",
          width: "200px",
        },
        {
          prop: "JobDate",
          label: "工作年限",
          // width: "90px",
        },
      ],
      options: [
        //切屏次数的选项
        {
          value: "0",
          label: "0",
        },
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
      ],
      cutscreen: 0, //切屏次数
      cheat_pwdinput: "", //防作弊六位数字密码
      // checkcode: isbotainData,
      rendersum: [],
      multipleSelection: [],
      client: null, //oss对象
      filestatus: "",
      checkpoint: "",
      percentage: 0,
      isShow: false,
      flang: false, // 定义oss是否成功
    };
  },
  components: {
    FourPup,
    Candidate,
  },
  methods: {
    // 重置
    reset() {
      this.input = "";
      this.isShow = false;
      this.searchResult();
    },
    // 搜索查询
    searchResult() {
      let articles_array = JSON.parse(JSON.stringify(this.getData)); // 一进来获取的列表数据
      let searchString = this.input; // input的数据
      if (searchString == "") {
        // 传空值的时候展示全部
        this.isShow = false;
        this.list_vip = articles_array;
      } else {
        this.isShow = true; // 展示查询出来的表格
        searchString = searchString.trim().toLowerCase();
        articles_array = articles_array.filter((item) => {
          return JSON.stringify(item).indexOf(searchString) != -1;
        });
        if (this.list_vip.length == 0) {
          this.$message.error(`未找到包含“${this.input}”信息的考生!

`);
          this.list_vip = JSON.parse(JSON.stringify(this.getData));
        } else {
          this.list_vip = articles_array;
        }
      }
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    async next() {
      this.getData = this.$refs.candidate.getData; // 勾中考生
      this.sundflag = true;
      if (this.isedite == 2) {
        this.$parent.back();
        return;
      }
      if (this.$parent.$parent.videoinfo != "kong") {
        this.savevideo();
        this.$message("修改成功");
        this.$parent.back();
        return;
      }
      if (this.getData.length > 0) {
        let selectid = this.getData.map((item) => {
          return item.UserID;
        });
        this.$parent.reqfrom.userArr = JSON.stringify(selectid);
        let status = await this.checkfilename();
        if (status == 200) {
          // 上传前校验是否上传过，通过过校验服务器容量
          let parmas = {
            guid: JSON.parse(localStorage.getItem("userlist")).guid,
            userID: JSON.parse(localStorage.getItem("userlist")).userID,
            hid: JSON.parse(localStorage.getItem("userlist")).hid,
          };
          let ressts = await resourcereq.getOSS_STS(parmas);
          if (ressts.data.Status == 200 && ressts.data.Data.AccessKeyId) {
            // 判断当前医院的空间容量是否还有空闲 有的话返回秘钥
            this.progressdialog.isshow = true;
            let _this = this;
            this.client.multipartUpload(
              this.$parent.$children[0].fileurl,
              this.$parent.$children[0].file,
              {
                progress: async function (p, checkpoint) {
                  try {
                    _this.progressdialog.percentagenum = p * 100;
                    if (p == 1) {
                      _this.progressdialog.isshow = false;
                      _this.flang = true; // 成功状态
                      // 如果OSS进度条上传到百分百的情况下执行创建视频
                      let res = await resourcereq.createVideo(
                        _this.$parent.reqfrom
                      ); //创建视频
                      if (res.data.Data === "ok" && res.data.Status == 200) {
                        _this.$message.success("上传视频成功");
                        _this.$parent.$parent.$children[0].getlist(); // 刷新主页列表
                      } else {
                        _this.$message.error(res.data.Data);
                      }
                      _this.$parent.back();
                    }
                  } catch (e) {
                    _this.$message.error("上传视频失败");
                  }
                },
              }
            );
            setTimeout(() => {
              this.sundflag = false;
            }, 500);
          } else {
            this.$message.error(ressts.data.Data);
          }
        } else if (status == 201) {
          this.$message.warning("视频名称已存在，请重新命名");
          this.sundflag = false;
        } else {
          this.$message.warning("服务器出错了");
          this.sundflag = false;
        }
      } else {
        this.$message.error("请添加考生");
        this.sundflag = false;
      }
    },
    handleChange(val) {
      console.log(val);
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      // this.getDateList(); // 重新发起请求
    },
    //批量删除
    delectArr() {
      if (this.multipleSelection.length < 1) {
        this.$refs.popup.deleteState = 2;
        this.$refs.popup.dialogVisibleObj.batchDelete = true;
      } else {
        this.$refs.popup.deleteState = 1;
        this.$refs.popup.dialogVisibleObj.batchDelete = true;
      }
    },
    handleCurrentChange(val) {
      this.currentPage3 = val;
      this.rendersum = this.pageData(this.currentPage3, 10, this.getData);
    },
    pageData: (number, pageSize, data) => {
      const pageList = [];
      const start = pageSize * number - pageSize;
      const end = pageSize * number;
      for (let i = start; i < end; i++) {
        pageList.push(data[i]);
      }
      const list = pageList.filter((item) => item);
      return list;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    back() {
      this.$parent.cutcoms(0);
    },
    async checkfilename() {
      let parmas = {
        name: this.$parent.$children[0].fileurl,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: "",
      };
      let res = await resourcereq.checkfilename(parmas);
      return res.data.Status;
    },
    async createOSS() {
      //这里面进行请求sts
      let parmas = {
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
      };
      let ressts = await resourcereq.getOSS_STS(parmas);
      this.client = new OSS({
        region: "oss-cn-shenzhen",
        accessKeyId: ressts.data.Data.AccessKeyId,
        accessKeySecret: ressts.data.Data.AccessKeySecret,
        bucket: "yingedu-video4",
        stsToken: ressts.data.Data.SecurityToken,
        secure: true,
      });
    },
    //
    //   await this.ossUpload(
    //     this.$parent.$children[0].fileurl,
    //     this.$parent.$children[0].file
    //   ); // 处理OSS
    //   // this.flang = false;
    //   //开始拼接createvideo
    //   if (this.flang == true) {
    //     // 如果OSS进度条上传到百分百的情况下执行创建视频
    //     let res = await resourcereq.createVideo(this.$parent.reqfrom); //创建视频
    //     if (res.data.Data === "ok" && res.data.Status == 200) {
    //       this.$parent.$parent.$children[0].getlist(); // 刷新主页列表
    //     } else {
    //       this.$message.error(res.data.Data);
    //     }
    //   } else {
    //     this.$message.error("很抱歉，上传视频失败!");
    //     return;
    //   }
    // },
    // async ossUpload(filename, file) {
    //   //获取拿到的oss对象进行发送请求。
    //   let _this = this;
    //   this.progressdialog.isshow = true;
    //   try {
    //     let result = await _this.client.multipartUpload(filename, file, {
    //       //OSS的实例方法执行，第一个参数是文件名，第二个文件对象，第三个是一个对象，对象内的属性表示上传的过程。
    //       //        表示进度回调函数，用于获取上传进度，可以是async的函数形式。回调函数包含三个参数：
    //       //percentage {Number}：进度百分比（0~1之间的小数）。
    //       //checkpoint {Object}：与[options] {Object}中的[checkpoint] {Object}定义相同。
    //       //res {Object}：单个分片上传成功返回的response。
    //       progress: function (p, checkpoint) {
    //         _this.checkpoint = checkpoint;
    //         _this.progressdialog.percentagenum = p * 100;
    //         if (p == 1) {
    //           _this.progressdialog.isshow = false;
    //           _this.flang = true; // 成功状态
    //           _this.$message({
    //             message: "上传视频成功",
    //             type: "success",
    //           });
    //           _this.$parent.back();
    //         }
    //       },
    //       checkpoint: _this.checkpoint,
    //     });
    //   } catch (e) {
    //     this.flang = false;
    //     // this.$message.error(e, "很抱歉，上传失败!");
    //   }
    // },
    // 去重
    unique() {
      let departArr = this.getData.map((item) => {
        return item.DepartmentName;
      });
      departArr = [...new Set(departArr)];
      return departArr.length;
    },
    // 添加科室
    async addExaminee() {
      //   let student = {
      //     guid: JSON.parse(loginvuex.state.userlist).guid,
      //     userID: JSON.parse(loginvuex.state.userlist).userID,
      //     hid: JSON.parse(loginvuex.state.userlist).hid,
      //   };
      //   let res = await getstudentlist.getstudentlist(student);
      //   // student.groupID = 19;
      //   // student.searchStr = "";
      //   let resa = await getstudentlist.getseekAndCreateExam(student);
      //   this.$refs.popup.getData = resa.data.Data[0];
      //   this.$refs.popup.keshioptions = resa.data.Data[1];
      //   this.$refs.popup.zhiweioptions = resa.data.Data[2];
      this.$refs.popup.submit();
      this.$refs.popup.dialogVisibleObj.addExamineeShow = true;
    },
    timechange() {
      //  this.StartDatestr = this.timeFormat(this.value1[0]);
      //this.EndDate = this.timeFormat(this.value1[1]);
    },
    savevideo() {
      //修改视频信息，
      let selectid = this.getData.map((item) => {
        return item.UserID;
      });
      this.$parent.reqfrom.userArr = JSON.stringify(selectid);
      this.$parent.reqfrom.videoID = this.$parent.$parent.videoinfo.VideoID;
      resourcereq.SaveVideoInfo(this.$parent.reqfrom);
    },
    timeFormat(time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month =
        time.getMonth() + 1 > 10
          ? time.getMonth() + 1
          : "0" + (time.getMonth() + 1);
      let day = time.getDate() >= 10 ? time.getDate() : "0" + time.getDate();
      let h = time.getHours() >= 10 ? time.getHours() : "0" + time.getHours(); //获取当前小时数(0-23)
      let m =
        time.getMinutes() >= 10 ? time.getMinutes() : "0" + time.getMinutes(); //获取当前分钟数(0-59)
      return year + "-" + month + "-" + day + " " + h + ":" + m;
    },
    delectstudent(row, val) {
      // this.getData.splice(val, 1);
      this.currentRowData = row;
      let userID = row.UserName; // 根据考试账号去删除
      let index = this.getData.findIndex((zitem) => {
        // 找到对应的索引删除
        return userID == zitem.UserName;
      });
      this.currentRow = index;
      this.currentRowData.index = val;
      this.$refs.popup.deleteState = 0;
      this.$refs.popup.dialogVisibleObj.batchDelete = true;
    },
    async initOss() {
      //这里面进行请求sts
      let parmas = {
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
      };
      // let ressts = await resourcereq.getOSS_STS(parmas);
      let ressts = await resourcereq.getCoursewareOSS_STS(parmas);
      if (ressts.data.Status == 200 && ressts.data.Data.AccessKeyId) {
        this.client = new OSS({
          region: "oss-cn-shenzhen",
          accessKeyId: ressts.data.Data.AccessKeyId,
          accessKeySecret: ressts.data.Data.AccessKeySecret,
          bucket: "yingedu-video4",
          stsToken: ressts.data.Data.SecurityToken,
          secure: true,
          // accessKeyId: "LTAI5tPu8jJMiMybUXUSpMvp",
          // accessKeySecret: "GchIFvJQfMngvzb71mTh2HboOUrqIJ",
          // bucket: "yingedu-video4",
        });
      }
    },
    async initial() {
      if (this.$parent.$parent.videoinfo != "kong") {
        this.types = 2;
        if (this.$parent.$parent.details == "details") {
          this.isedite = 2;
        } else {
          this.isedite = 1;
        }
        let parma = {
          videoID: this.$parent.$parent.videoinfo.VideoID,
          guid: JSON.parse(localStorage.getItem("userlist")).guid,
          userID: JSON.parse(localStorage.getItem("userlist")).userID,
          hid: JSON.parse(localStorage.getItem("userlist")).hid,
        };
        const { data } = await resourcereq.getVideo(parma);
        if (data.Status == 200) {
          this.getData = data.Data[1][0];
          this.getData = this.getData.map((item) => {
            for (let ztiem in item) {
              if (item[ztiem] === "" || item[ztiem] === null) {
                item[ztiem] = "未设置";
              }
            }
            item.Birthday1 = this.$moment(item.BeginTime).format(
              "YYYY/MM/DD HH:mm"
            );
            return item;
          });
          this.list_vip = JSON.parse(JSON.stringify(this.getData));
          this.isShow = true;
          this.editType = true;
        } else {
          this.$message.error(data.Data);
        }
      } else {
        this.isShow = true;
        this.loading = false;
        this.types = 1; // 新增状态
      }
    },
  },
  async created() {
    this.initOss();
    this.initial();
  },
};
</script>

<style lang="scss" scoped>
.father_box {
  margin-top: 24px;
}
.baic_content {
  background-color: white;
  //  margin-top: 24px;
  min-width: 1527px;
  // padding-bottom: 50px;
  border-radius: 4px 4px 4px 4px;
  .bacle_input {
    display: flex;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      min-width: 142px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
      &::before {
        content: "*";
        width: 20px;
        display: inline-block;
        color: #ff0000;
      }
      &:nth-child(3) {
        margin-left: 57px;
      }
    }
    .el-button {
      width: 162px;
      height: 40px;
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
      margin-left: 30px;
      color: #ffffff;
    }
  }
  .check_textarea {
    width: 825px;
    ::v-deep .el-textarea__inner {
      width: 825px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_input {
    width: 632px;
    ::v-deep .el-textarea__inner {
      width: 632px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 12px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}
.prompt {
  width: 147px;
  height: 28px;
  padding: 2px 1px;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0 70px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-card__body {
  padding: 0;
}
::v-deep .el-collapse-item__header {
  height: 60px;
  line-height: 60px !important;
  background: #d8edff;
  border-radius: 10px 10px 0px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 19px;
  color: #333333;
  padding: 0px 24px;
}
.main_form {
  border-radius: 13px 13px 0px 0px;
  // height: 760px;
  margin-bottom: 24px;
  ::v-deep .el-collapse-item__arrow {
    font-weight: bolder;
  }
  .son_input {
    // height: 500px;
    .bacle_input {
      align-items: center;
      .standard_input {
        width: 825px;
        height: 40px;
        display: flex;
        align-items: center;
      }
      .text_field {
        width: 673px;
        height: 126px;
      }
      margin-top: 24px;
      padding-right: 40px;
      display: flex;
      p {
        margin-left: 20px;
      }
      h5 {
        min-width: 160px;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 400;
        text-align: left;
        line-height: 40px;
        padding-left: 20px;
        margin-right: 10px;
        &::before {
          content: "*";
          width: 20px;
          display: inline-block;
          color: #ff0000;
        }
      }
      .icont_pop {
        position: relative;
        i {
          display: inline-block;
          position: absolute;
          right: 34px;
          top: 0px;
          color: #d9d9d9;
          // transform: scale(0.6);
          font-size: 20px;
          color: #d8edff;
        }
      }
      .icont_hover {
        position: relative;
        i {
          display: inline-block;
          position: absolute;
          right: 6px;
          top: 0px;
          color: #d9d9d9;
          // transform: scale(0.6);
          font-size: 20px;
          color: #d8edff;
        }
      }
    }
  }
}
.isallowqieping {
  width: 280px;
  display: flex;
  align-items: center;
  margin-left: 170px;
  > p {
    font-size: 16px;
    color: rgb(160, 158, 158);
  }
  .qiepingcishu {
    width: 60px;
  }
}
.cheat_pwdinput {
  width: 200px;
  margin-left: 170px;
  margin-top: 10px;
}
.special_input {
  display: flex;
  margin-top: 24px;
  .special_box {
    width: 673px;
    height: 126px;
  }
  h5 {
    min-width: 160px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    &::before {
      content: "*";
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
  }
}
.title_box {
  display: flex;
  justify-content: space-between;
  margin: 24px 16px 24px 24px;
  .search_view {
    display: flex;
    .search {
      display: flex;
      width: 300px;
      height: 40px;
      .el-button {
        width: 40px;
        height: 40px;
        background: #1890ff;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #1890ff !important;
        border-radius: 0px 4px 4px 0px !important;
        i {
          display: inline-block;
        }
      }

      ::v-deep .el-input__inner {
        border-radius: 4px 0px 0px 4px !important;
      }
    }
  }
  .searchbtn {
    margin-left: 14px;
    margin-right: 12px;
  }
}
// 按钮
.operation_box {
  display: flex;
  opacity: 1;
  height: 40px;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 24px;
    color: #ffffff;
    letter-spacing: 1px;
    border: none !important;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    width: 74px;
    height: 40px;
    background: #1890ff;
  }
  .el-button:nth-child(2) {
    width: 127px;
    height: 40px;
    background-color: #e54d4d;
  }
  .el-button:nth-child(3) {
    width: 104px;
    height: 40px;
    background: #00d254;
    span > i {
      margin-right: -2px !important;
    }
  }
}
// 表单
.examinee_form {
  padding: 0 24px;
  p {
    padding: 10px 24px;
    height: 42px;
    background: #eef7ff;
    opacity: 1;
    border-radius: 4px 4px 0px 0px;
    font-weight: 400;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;

  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
  ::v-deep .el-pagination__jump {
    &::before {
      content: "10条/页";
      width: 82px;
      border: 1px solid #d9d9d9;
      height: 28px;
      border-radius: 2px;
      text-align: center;
      display: inline-block;
      margin-right: 8px;
      cursor: pointer;
    }
  }
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
::v-deep .el-table td div:nth-child(1) {
  text-align: center;
}
.null_view {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 500px;
}
</style>
